'use client';

import Link from 'next/link';
import { LogoBlackIcon } from '../../icons';
import BookDemoForm from '../BookDemoForm';

export default function LandingFooter() {
  return (
    <footer className='flex w-full justify-center border-t border-black/25 pt-10 pb-12'>
      <div className='tablet:flex-col mobile:px-4 flex w-full justify-center px-10'>
        <div className='tablet:mr-0 tablet:w-full mr-20 w-80'>
          <LogoBlackIcon className='mb-4' />
          <p>
            Booli Pro är ett analysverktyg för dig som professionellt fattar beslut på bostadsmarknaden. Vi hjälper till
            att underlätta rätt beslut i ditt arbete.
          </p>
        </div>
        <div className='tablet:mt-6 mobile:flex-wrap flex gap-x-20'>
          <div className='mobile:mt-4'>
            <h3 className='font-display text-lg'>Bli kund</h3>
            <ul className='mt-4 space-y-2'>
              <li className='link w-max cursor-pointer'>
                <BookDemoForm Trigger={<button type='button'>Boka demo</button>} />
              </li>
              <li>
                <Link
                  href={'/#services'}
                  className='link cursor-pointer'
                >
                  Våra tjänster
                </Link>
              </li>
              <li>
                <Link
                  className='link'
                  href='/indices'
                >
                  Prisindex
                </Link>
              </li>
            </ul>
          </div>
          <div className='mobile:mt-4'>
            <h3 className='font-display text-lg'>Om Booli Pro</h3>
            <ul className='mt-4 space-y-2'>
              <li>
                <a
                  className='link'
                  target='_blank'
                  rel='noreferrer'
                  href='https://www.booli.se/p/om-booli'
                >
                  Om oss
                </a>
              </li>
              <li>
                <a
                  className='link'
                  target='_blank'
                  rel='noreferrer'
                  href='https://www.booli.se/kunskap/jobba-hos-oss/'
                >
                  Jobba hos oss
                </a>
              </li>
            </ul>
          </div>
          <div className='mobile:mt-4'>
            <h3 className='font-display text-lg'>Övrigt</h3>
            <ul className='mt-4 space-y-2'>
              <li>
                <a
                  className='link'
                  target='_blank'
                  rel='noreferrer'
                  href='https://www.sbab.se'
                >
                  SBAB
                </a>
              </li>
              <li>
                <a
                  className='link'
                  target='_blank'
                  rel='noreferrer'
                  href='https://www.booli.se'
                >
                  Booli
                </a>
              </li>
              <li>
                <a
                  className='link'
                  target='_blank'
                  rel='noreferrer'
                  href='https://www.hittamaklare.se'
                >
                  Hittamäklare
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}
